import React, { FC } from 'react';
import { Icon, Typography } from '@packages/ui/shared';
import colors from '@packages/core/styles/colors';
import { createUseStyles } from 'react-jss';

export interface ToastSuccessMessageProps {
    toastData: string;
    iconName: string;
    iconColor: keyof typeof colors;
    backgroundColor?: keyof typeof colors;
}

const useStyles = createUseStyles({
    container: {
        display: 'flex',
        maxWidth: 'auto',
        justifyContent: 'center',
        alignItems: 'center',
        top: 75,
        left: '50%',
        transform: 'translateX(-50%)',
        height: 40,
        borderRadius: 4,
        paddingTop: 8,
        paddingRight: 16,
        paddingBottom: 8,
        paddingLeft: 16,
        gap: 8,
        position: 'absolute',
        zIndex: '10001',
    },
});

export const ToastSuccessMessage: FC<ToastSuccessMessageProps> = ({
    toastData,
    iconName,
    iconColor,
    backgroundColor,
}) => {
    const styles = useStyles();
    const resolvedBackgroundColor = backgroundColor ? colors[backgroundColor] : colors.black;

    return (
        <div className={styles.container} style={{ backgroundColor: resolvedBackgroundColor }}>
            <Icon name={iconName} color={iconColor} />
            <Typography
                style={{
                    fontFamily: 'Roboto',
                    fontWeight: 600,
                    fontSize: 15,
                    color: '#FFFFFF',
                }}
            >
                {toastData}
            </Typography>
        </div>
    );
};
